import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";

import { withSpinner } from "../../extensions/withSpinner.extension";
import { API_ROOT } from "../../types/constants/appconstants";
import { DocumentUploadInfo } from "../../types/documentuploadinfo";
import { DocumentUploadModel } from "../../types";

@Injectable({
    "providedIn": "root"
})
export class DocumentsService {
    private http = inject(HttpClient);
    private documentsBaseUrl = inject(API_ROOT) + "api/documentManagement";

    uploadDocument(files: DocumentUploadInfo<unknown>[]): Observable<DocumentUploadModel[]> {
        return withSpinner(this.http).post<DocumentUploadModel[]>(`${this.documentsBaseUrl}/upload`, files);
    }

    uploadComplete(blobStagingIds: number[]): Observable<any> {
        return withSpinner(this.http).post(`${this.documentsBaseUrl}/uploadComplete`, blobStagingIds);
    }
}